import { atom, selector, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * 진행 표시 줄
 */
// atom
const progressState = atom({
  key: 'progressState',
  default: {
    isShow: false,
    label: '{now}%',
    now: 0,
    style: {}
  }
});

// selector
const progressSelector = selector({
  key: 'progressSelector',
  get: ({ get }) => get(progressState),
  set: ({ set }, newValue) =>
    set(progressState, prevState => ({ ...prevState, ...newValue }))
});

// hook
function useProgressState() {
  const [progress, setProgress] = useRecoilState(progressSelector);
  const resetProgress = useResetRecoilState(progressState);

  return {
    progress,
    setProgress,
    resetProgress
  };
}

export default useProgressState;
